// Telas que existem só para alguns tipos de ERP (a funcionalidade só foi
// integrada nesses ERPs). Este mapa decide a rota (App.js), o item do menu
// (pages/internal/layout) e quais ERPs aparecem no select da tela
// (components/erp/useErpSelecionado).
//
// Para liberar uma destas telas para outro ERP: inclua o tipo aqui e
// implemente o `case` dele nos models do backend que a tela chama.
import { temErp } from "./erpSistema";

export const TELAS_POR_ERP = {
  "/interno/suporte/fluxoOs": ["IXC"],
  "/interno/suporte/os": ["IXC"],
  "/interno/suporte/workSpace": ["HUBSOFT", "IXC"],
  "/interno/relatorio-reincidencia": ["HUBSOFT"],
};

/** Tipos de ERP que têm a tela, ou null se ela vale para qualquer ERP. */
export function tiposDaTela(rota) {
  return TELAS_POR_ERP[rota] || null;
}

/** A tela existe neste sistema (algum ERP dela está em uso)? */
export function telaDisponivel(rota) {
  const tipos = tiposDaTela(rota);
  return !tipos || tipos.some((tipo) => temErp(tipo));
}

// Buscador global por protocolo de cada tela: o que cada tipo de ERP permite
// buscar ("ticket" por protocolo, "os" por número). Para liberar uma busca
// para um ERP: inclua aqui e garanta que a tela sabe exibir o resultado dele
// (a rota do backend — ticketDetails/osDetails/protocolo — já roda no ERP
// escolhido).
export const BUSCA_PROTOCOLO_POR_ERP = {
  "/interno/suporte/atendimentos": { HUBSOFT: ["ticket", "os"], IXC: ["ticket"] },
  "/interno/suporte/fluxoOs": { IXC: ["os"] },
};

/** Tipos de busca da tela para o tipo de ERP escolhido (lista vazia = nenhuma). */
export function tiposDeBusca(rota, tipoErp) {
  return BUSCA_PROTOCOLO_POR_ERP[rota]?.[tipoErp] || [];
}
